/*
 * Flash sale countdown bar. Shared by the Flash Sale Bar section and the
 * inline bar in the Flash Sale Collection section.
 *
 * data-start / data-end are Unix timestamps in milliseconds, rendered by
 * Liquid in the shop's timezone, so every visitor counts down to the same
 * instant regardless of their own timezone.
 *
 * data-hide-target (optional) is a selector for an ancestor to hide when the
 * sale ends; defaults to the bar itself.
 *
 * The script can be included by several sections on one page, so each bar is
 * marked once it has been initialised.
 */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function formatHms(ms) {
    var s = Math.floor(ms / 1000);
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
  }

  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }

  function initBar(bar) {
    if (bar.dataset.fsInit) return;
    bar.dataset.fsInit = 'true';

    var startTs = parseInt(bar.dataset.start, 10);
    var endTs   = parseInt(bar.dataset.end, 10);
    if (!endTs) return;

    var trackEl  = bar.querySelector('.flash-sale-bar__track');
    var timerEl  = bar.querySelector('.flash-sale-bar__timer');
    var textEl   = bar.querySelector('.flash-sale-bar__text');
    var fillEl   = bar.querySelector('.flash-sale-bar__fill');
    var hideEl   = (bar.dataset.hideTarget && bar.closest(bar.dataset.hideTarget)) || bar;
    var lastWidth;

    function tick() {
      // Section was removed (e.g. re-rendered in the theme editor)
      if (!bar.isConnected) return;

      var now = Date.now();

      if (now >= endTs) {
        hideEl.hidden = true;
        hideEl.style.display = 'none';
        return;
      }

      if (startTs && now < startTs) {
        var days = Math.ceil((startTs - now) / 86400000);
        timerEl.textContent = days + (days === 1 ? ' day' : ' days');
        textEl.textContent  = 'Until flash sale';
        trackEl.hidden = true;
        // Wake again at the next minute or at sale start, whichever is first
        setTimeout(tick, Math.min(60000, startTs - now));
        return;
      }

      timerEl.textContent = formatHms(endTs - now);
      textEl.textContent  = 'Until sale ends';
      trackEl.hidden = false;

      if (startTs) {
        var width = clamp((endTs - now) / (endTs - startTs) * 100, 0, 100).toFixed(1) + '%';
        if (width !== lastWidth) {
          fillEl.style.width = width;
          lastWidth = width;
        }
      } else {
        fillEl.style.width = '100%';
      }

      // Align to the next whole second so the display never skips or repeats
      setTimeout(tick, 1000 - (now % 1000) + 5);
    }

    tick();
  }

  function initAll() {
    document.querySelectorAll('.flash-sale-bar[data-end]').forEach(initBar);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
